<template>
    <ContentOrLoading>
        <ShowSvgSectionsComponent
            v-if="svg"
            :secciones="secciones"
            :zona_id="zona_id"
            :svg="svg"
            :strictRegions="strictRegions"
            @clickZona="clickRegion"
        />
    </ContentOrLoading>
</template>

<script>
    import ShowSvgSectionsComponent from '@/components/common/svg/secciones/ShowSvgSectionsComponent.vue';

    // The strict "no disponible" tooltip treatment only applies to these
    // teatros. Other clubs (and the admin taquilla flow) keep the legacy
    // behaviour untouched.
    const HASHES_WITH_STRICT_PRICES = ['J1fKG9AarPuPNJ5hwY0t', 'D5IcOz5iKX8EdfkoQ6NF'];

    export default {
        props: {
            secciones: {
                type: Array,
                required: true
            }, 
            zona_id: {
                type: Number,
                required: false
            }
        },
        data() {
            return {
                svg : null,
            }            
        },
        created() {
            this.getSvgCode();
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            },
            strictRegions() {
                var hash = (this.$store.getters.getConfig || {}).hash_teatro;
                return HASHES_WITH_STRICT_PRICES.indexOf(hash) !== -1;
            }
        },
        methods : {
            getSvgCode() {
                this.loading = true;

                const params = {
                    filters: {},
                    recinto_id: this.recinto.id,
                    lista_abonado_id: this.lista_abonados.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.temporada.recinto.secciones.svg'), params).then(res => {
                    this.svg = res.data.svg;
                });
            },
            clickRegion(zona) {
                this.$emit('clickZona', zona);          
            }        
        },
        components: {
            ShowSvgSectionsComponent
        }
    }
</script>